<template>
    <div :class="containerClass" style="width: max-content;">
        <span role="status" aria-live="polite">Current Queue Status: <span class="fw-bold">{{ isPaused ? 'Paused' : 'Running' }}</span></span>
        <button class="btn btn-link" @click.prevent="handlePauseResumeClick" :aria-label="currentTooltipText" v-tooltip="currentTooltipText" v-if="showPauseResumeButton">
            <span v-if="!isPaused"><i class="bi bi-pause-fill" aria-hidden="true"></i></span>
            <span v-if="isPaused"><i class="bi bi-play-fill" aria-hidden="true"></i></span>
        </button>        
    </div>
</template>
<script setup lang="ts">
import { computed, ref, watch, PropType, onMounted } from 'vue';
import { useQueueStore } from '@/stores/queueStore';

const props = defineProps<{
    showPauseResumeButton: Boolean,
    containerClass?: string
}>()
const queueStore = useQueueStore();
const isPaused = ref(false);
var tooltipText = ref("Click here to pause the queue");

const currentTooltipText = computed(()=> { return tooltipText.value; });

function setToolTipText(){
    if(isPaused.value){
        tooltipText.value = "Click here to resume the queue";
    }
    else {
        tooltipText.value = "Click here to pause the queue";
    }   
} 

function getQueueStatus(){
    queueStore.getQueueStatus().then((result) => {
        if(result != undefined && typeof(result.data) == 'boolean') {
            isPaused.value = result.data;
        }

        setToolTipText();
    });
}

function handlePauseResumeClick(){

    queueStore.changeQueueStatus(!isPaused.value).then(() => {
        getQueueStatus();
    });
}

onMounted(() => {

    getQueueStatus();
});

</script>